import type {ApiRouter} from '@app/api-resolver/router'
import {createTRPCReact} from '@trpc/react-query'

export const api = createTRPCReact<ApiRouter>()
